/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import React, { useContext } from 'react';
import Axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

export const axios = Axios.create({
  baseURL: '',
});

export class DataLayerClient {
  private baseUrl: string;

  constructor(baseUrl?: string) {
    this.baseUrl = baseUrl || '';
  }

  /**
   * @param clientId (optional)
   * @return Success
   */
  get(
    clientId: string | null | undefined,
    $config?: AxiosRequestConfig
  ): AxiosPromise<DataLayerDto> {
    let url = this.baseUrl + '/api/data-layer';

    return axios.request<DataLayerDto>({
      url: url,
      method: 'GET',
      params: {
        clientId: clientId,
      },
      ...$config,
    });
  }

  /**
   * @param request
   * @return Success
   */
  post(
    request: CreateOrUpdateDataLayerRequest,
    $config?: AxiosRequestConfig
  ): AxiosPromise<unknown> {
    let url = this.baseUrl + '/api/data-layer';

    return axios.request<unknown>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  }
}
export class HealthMonitorClient {
  private baseUrl: string;

  constructor(baseUrl?: string) {
    this.baseUrl = baseUrl || '';
  }

  /**
   * @return Success
   */
  get($config?: AxiosRequestConfig): AxiosPromise<File> {
    let url = this.baseUrl + '/api/healthmonitor';

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  }
}

export const clients = {
  dataLayerClient: new DataLayerClient(),
  healthMonitorClient: new HealthMonitorClient(),
};

export const ClientContext = React.createContext(clients);

export function useClient() {
  return useContext(ClientContext);
}

function serializeQueryParam(obj: any) {
  if (obj === null || obj === undefined) return '';
  if (obj instanceof Date) return obj.toJSON();
  if (typeof obj !== 'object' || Array.isArray(obj)) return obj;
  return Object.keys(obj)
    .reduce((a: any, b) => a.push(b + '=' + obj[b]) && a, [])
    .join('&');
}
export interface CreateOrUpdateDataLayerRequest {
  clientId?: string;
  dataLayer?: string;
}

export interface DataLayerDto {
  dataLayer: string;
}
